export const ES_TRANSLATIONS = {
	translation: {
		BUTTON_TEXT_PRE_APP: 'Enviar',
		DIAL_COUNTRY_SELECTOR: 'País',
		COUNTRY_SELECTOR: 'País',
		DOCUMENT_TYPE_SELECTOR: 'Seleccione su documento',
		BUTTON_LOADING: '... Enviando',
		TAB_TITLE: 'Latú - Seguros empresariales hechos con Tecnología',
		PRE_APPLICATION_TAB_TITLE: 'Let’s cover your Business',
		STEPS_TITLE: 'Pasos',
		NEXT: 'Siguiente',
		BACK: 'Atras',
		YES: 'Sí',
		NOT: 'No',
		COMPLETE: 'Completado',
		QUOTE_INTRO_1: `¡Excelentes noticias! Aquí encontrará las propuestas que hemos elaborado para adaptarnos a las necesidades de su empresa.`,
		QUOTE_INTRO_2: 'Seguro: ',
		QUOTE_INTRO_3: `Por favor, seleccione entre las opciones a continuación la propuesta que mejor se adapte a sus necesidades. Cada propuesta ofrece diferentes coberturas.`,
		QUOTE_INTRO_RECOMMENDATION_LIMIT: 'Límite de recomendación: ',
		QUOTE_COVERAGE_TITLE: 'Cobertura:',
		QUOTE_COVERAGE_SUBTITLE:
			'Este es el valor máximo que pagará la aseguradora en caso de un siniestro.',
		QUOTE_PREMIUM_TITLE: 'Prima:',
		QUOTE_PREMIUM_SUBTITLE: 'El monto a ser pagado por el asegurado.',
		QUOTE_COUNTRIES_COVERAGE_TITLE: 'Países cubiertos:',
		QUOTE_CONTRACT_COVERAGES_TITLE: 'Coberturas:',
		QUOTE_EXCLUSIONS_TITLE: 'Exclusiones:',
		QUOTE_ADDITIONAL_COVERAGES_TITLE: 'Coberturas Adicionales:',
		QUOTE_OTHER_CONDITIONS_TITLE: 'Otras Condiciones:',
		QUOTE_PAYMENT_SCHEDULE_TITLE: 'Formas de pago:',
		QUOTE_PAYMENT_SCHEDULE:
			'Hasta 4 cuotas sin interés o 7 cuotas con un interés del 1,5% por mes.',
		QUOTE_MORE_INFO:
			'En Latú, estamos comprometidos en ayudarte en todas las etapas de tu trayectoria, así que si necesitas ayuda o tienes preguntas, simplemente envíanos un mensaje o programa una reunión - nuestro equipo estará encantado de orientarte.',
		QUOTE_SCHEDULE_MEET: 'Agendar una reunión',
		QUOTE_INSTALLMENTS_INFO: '{{numberOfInstallments}} cuotas de {{value}}',
		QUOTE_SELECT_BUTTON: 'Confirmar',
		QUOTE_SUCCESS_MESSAGE:
			'¡Gracias por elegirnos! Nuestro equipo de profesionales de seguros se pondrá en contacto contigo pronto para comenzar el proceso.',
		DENIED_TITLE: 'NEGADO',
		DENIED_SUB_TITLE:
			'La compañía de seguros ha denegado el acceso a una póliza.',
		MANDATORY_FIELD: 'Campo Obligatorio',
		YES_LABEL: 'Si',
		NOT_LABEL: 'No',
		SUCCESS_TITLE: '¡Gracias!',
		SUCCESS_SUB_TITLE: 'Nos pondremos en contacto pronto.',
		SUCCESS_BUTTON_BACK: 'Volver a la página principal',
		USER_TYPE_SELECTION_PAGE_TITLE: 'Conociendo su negocio',
		USER_TYPE_SELECTION_PAGE_SUB_TITLE:
			'!Hola! Es muy bueno tenerte aquí. Para empezar, infórmenos:',
		USER_TYPE_SELECTION_PAGE_PJ_SELECTION: 'Soy una empresa',
		USER_TYPE_SELECTION_PAGE_PJ_SELECTION_DESC:
			'Soy una empresa con CNPJ buscando seguros',
		USER_TYPE_SELECTION_PAGE_PF_SELECTION: 'Soy una persona física',
		USER_TYPE_SELECTION_PAGE_PF_SELECTION_DESC:
			'Soy una persona con CPF buscando seguros',
		PLACEHOLDER_FULL_NAME: 'Nombre completo',
		HOME: 'Inicio',
		HOME_PAGE_MENU: 'Página de inicio',
		COVERAGE_PAGE_MENU: 'Productos Latú',
		QUOTES_PAGE_MENU: 'Cotizaciones',
		PROFILE_SETTINGS_MENU: 'Configurações de perfil',
		HELP_CENTRAL_MENU: 'Centro de ayuda',
		LOGOUT_MENU: 'Salir',
		LOGOUT_MENU_CANCEL: 'Cancelar',
		LOGOUT_CONFIRMATION: '¿Estás seguro de que quieres salir?',
		BANNER_INFO_EXPERIENCE_TO_TAKE_RISKS:
			'Experimenta la paz de poder correr riesgos. Haz tu cotización de cobertura.',
		BANNER_INFO_CA_QUOTE_NOW: 'Cotizar ahora',
		ALERT_INFO_COVERAGE_YOUR_NEEDS:
			'¿No sabes qué seguro se ajusta a tus necesidades?',
		ALERT_INFO_CA_FIND_OUT_HERE: 'Descubre aquí',
		COVERAGE_PAGE_TITLE: '¿Qué seguros está buscando?',
		COVERAGE_PAGE_SUB_TITLE:
			'Para ofrecerte la mejor opción, selecciona uno o más seguros que tu empresa necesite.',
		DYO_CARD_TITLE: '----',
		DYO_CARD_DESCRIPTION:
			'Proteción para administradores ante reclamaciones relacionadas a su gestión',
		PROFESSIONAL_RESPONSIBILITY_CARD_TITLE: '-------',
		PROFESSIONAL_RESPONSIBILITY_CARD_DESCRIPTION:
			'Cubre su negocio contra las pérdidas sufridas por los clientes que reclaman errores en su servicio',
		CYBER_CARD_TITLE: '-----',
		CYBER_CARD_DESCRIPTION:
			'Proteción ante ciberamenazas cómo ataques hacker y vazamento de datos',
		CARD_TEXT_BUTTON_CALLBACK: 'Selecciona',
		CARD_TEXT_LINK_CALLBACK: 'Más información',
		MODAL_WANT_TO_TALK_TITLE: '¿Cómo quieres hablar con nuestro equipo?',
		MODAL_WANT_TO_TALK_SUB_TITLE:
			'¡Estamos aquí para ayudarte! Elige la mejor forma de contactar:',
		MODAL_WANT_TO_TALK_WHATSAPP_TITLE: 'WhatsApp',
		MODAL_WANT_TO_TALK_WHATSAPP_INFO: 'Habla con nuestro equipo especializado.',
		MODAL_WANT_TO_TALK_SCHEDULED_TITLE: 'Reserva una reunión.',
		MODAL_WANT_TO_TALK_SCHEDULED_INFO:
			'Habla con nosotros y resuelve todas tus dudas.',
		MODAL_WANT_TO_TALK_EMAIL_INFO:
			'Ponte en contacto con nuestro equipo de expertos',
		SIDEBAR_COMPANY_INFORMATION_TITLE: 'Información de la empresa',
		SIDEBAR_LABEL_COMPANY_NAME: 'Nombre de la empresa',
		SIDEBAR_LABEL_FULL_NAME: 'Nombre del empleado',
		SIDEBAR_LABEL_EMAIL: 'Correo electrónico del empleado',
		SIDEBAR_LABEL_WEBSITE: 'Sitio web de la empresa',
		SIDEBAR_LABEL_ADMIN_EMAIL: 'Nombre del administrador',
		SIDEBAR_LABEL_ADMIN_FULL_NAME: 'Correo electrónico del administrador',
		SIDEBAR_COMPANY_INFORMATION_EDIT_BUTTON: 'Editar datos',
		ALERT_INFO_HAS_INSURANCE: 'Tienes seguros con Latú',
		ALERT_INFO_DONT_HAS_INSURANCE: 'No tienes seguros con Latú',
		DRAG_AND_DROP_FILE_TEXT: 'Arrastra y suelta el archivo aquí',
		TOTAL_EMPLOYEES_COPY: 'Total de empleados',
		IPAF_TAB_TITLE: 'Application Form',
		FINISH: 'Finalizar',
		SUCCESS_UPLOAD_FILE:
			'We have received your file now you can continue with the process',
		IPAF_SUCCESS_TITLE: 'Gracias por la información',
		IPAF_SUCCESS_SUBTITLE:
			'Vamos trabajar para entregarte una cotización para tu negocio lo más pronto posible.',
		IPAF_SUCCESS_DETAIL_TITLE: 'Tiempo de espera',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_1:
			'El proceso de análisis lleva de 10 a 15 días hábiles.',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_2:
			'¡No te preocupes, te mantendremos actualizado sobre todas las novedades del proceso!',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_3: 'Comprende el proceso de contratación:',
		IPAF_SUCCESS_STEP_1: 'Llenado de datos',
		IPAF_SUCCESS_STEP_2: 'Análisis de cotización',
		IPAF_SUCCESS_STEP_3: 'Presentación de propuesta de cotización',
		IPAF_SUCCESS_STEP_4: 'Cobertura activa',
		IPAF_SUCCESS_STEP_HERE: 'Estás aquí',
		ERROR_NAME_EMPTY: 'El nombre no puede estar vacio',
		LINK_ADDITIONAL_UPLOAD_COPY: 'Plantilla para copiar y editar',
		TALK_WITH_EXPERT_TITLE: 'Habla con tu experto en seguros',
		TALK_WITH_EXPERT_COPY:
			'Cuenta con un servicio personalizado para tu cuenta',
		ALL_SET_TITLE: 'Activa tu cuenta',
		ALL_SET_COPY:
			'Por favor, haz clic en el enlace que hemos enviado a {{email}} para verificar tu cuenta y continuar.',
		PO: 'Portuges',
		SP: 'Español',
		ES: 'Español',
		EN: 'Inglés',
		BR: 'Brasil',
		MX: 'México',
		CO: 'Colombia',
		US: 'Estados Unidos',
		IPAF_PENDING_ALERT_TITLE: 'Tiene un formulario en proceso.',
		IPAF_PENDING_ALERT_INTRO:
			'Completa el formulario para obtener la cotización de tu seguro.',
		IPAF_PENDING_ALERT_TEXT_CALL_TO_ACTION: 'Finalizar formulario',
		MODAL_IPAF_CONFIRMATION_TITLE:
			'¿Estás seguro de que quieres terminar más tarde? ',
		MODAL_IPAF_CONFIRMATION_SUB_TITLE: 'Tu progreso será guardado.',
		MODAL_IPAF_CONFIRMATION_BUTTON_CONTINUE: 'Continuar llenando',
		MODAL_IPAF_CONFIRMATION_BUTTON_SAVE: 'Terminar más tarde',
		LIGHT_TABLE_TITLE: 'Tus procesos por estado',
		LIGHT_TABLE_HEADER_PROCESS_NAME: 'Nombre',
		LIGHT_TABLE_HEADER_UPDATED_AT: 'Última actualización',
		LIGHT_TABLE_HEADER_STATUS: 'Status',
		LIGHT_TABLE_HEADER_ACTION: 'Acción',
		IPAF_STATUS_IN_PROGRESS: 'En Progreso',
		IPAF_STATUS_PENDING_REVIEW: 'En Progreso',
		IPAF_STATUS_EXPIRED: 'Expirado',
		IPAF_STATUS_QUOTING: 'Cotizando',
		IPAF_STATUS_QUOTE_READY: 'Cotización lista',
		LIGHT_TABLE_LINK_ACTION_CONTINUE: 'Continuar',
		LIGHT_TABLE_LINK_ACTION_VIEW_EDIT_QUESTIONS: 'Continuar',
		LIGHT_TABLE_LINK_ACTION_VIEW_QUOTE: 'Ver cotización',
		SELECT_PRODUCT_COPY: 'Seleccionar producto',
		ACTION_CLOSE_FROM_SUCCESS_PAGE: 'Cerrar',
		QUESTION_CONFIRMATION_WELCOME_TITLE:
			'Bienvenido al formulario de Seguro Empresarial de Latú.',
		QUESTION_CONFIRMATION_INFO:
			'Antes de completar nuestro formulario, echa un vistazo a estos 3 consejos:',
		QUESTION_CONFIRMATION_CAPTION:
			' *En caso de que lo necesite, utilice el botón de retroceso para revisar las preguntas que ya ha respondido.',
		QUESTION_CONFIRMATION_SECURE_DATA_TITLE: 'Tus datos estarán seguros:',
		QUESTION_CONFIRMATION_SECURE_DATA_SUB_TITLE:
			'Nos tomamos la seguridad en serio y hemos implementado todas las medidas para garantizar la confidencialidad y seguridad de tu información.',
		QUESTION_CONFIRMATION_NEEDS_TITLE:
			'Tu información siempre estará guardada.',
		QUESTION_CONFIRMATION_NEEDS_SUB_TITLE:
			'Buscaremos la mejor solución para tu empresa y para ello necesitamos cierta información. Si necesitas parar, tu progreso se guardará y podrás continuar más tarde desde donde lo dejaste.',
		QUESTION_CONFIRMATION_WE_ARE_FOR_YOU_TITLE:
			'Estamos aquí para lo que necesites:',
		QUESTION_CONFIRMATION_WE_ARE_FOR_YOU_SUB_TITLE:
			'Nuestro equipo está siempre disponible y estaremos encantados de ayudar o responder cualquier pregunta que puedas tener. Haz clic en el botón de chat si tienes alguna pregunta durante el proceso.',
		QUESTION_CONFIRMATION_BUTTON_CONTINUE: 'Siguiente',
		QUESTION_CONFIRMATION_BUTTON_START: 'Comenzar',
		WELCOME_MESSAGE: 'Bienvenido',
		CONFIRMATION_MODAL_START_NEW_IPAF_TITLE: 'Ya tienes un proceso en curso',
		CONFIRMATION_MODAL_START_NEW_IPAF_INTRO:
			'Si inicias un nuevo proceso, la información actual se perderá.',
		CONFIRMATION_MODAL_START_NEW_IPAF_INTRO_1:
			'será reemplazado por este nuevo.',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_TO_CONTINUE:
			'¿Deseas continuar?',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_BUTTON_ACTION_CONTINUE_OLD:
			'Continuar con el proceso actual',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_BUTTON_ACTION_CONTINUE_NEW:
			'Iniciar un nuevo proceso',
		BUTTON_START_NEW_IPAF: 'Iniciar',
		ANSWER_PAGE_TITLE: 'Revisa tus respuestas',
		ANSWER_PAGE_INTRO:
			'Asegúrate de que toda la información sea correcta antes de finalizar. Esta información se utilizará para proporcionar la cobertura de seguro adecuada para tu negocio.',
		ANSWER_PAGE_BUTTON: 'Siguiente',
		COVERAGE_DETAIL_PAGE_BACK_TO_HOME_LINK:
			'Volver a la página inicial de Cotizaciones',
		COVERAGE_DETAIL_PAGE_TITLE: 'Cotizaciones para: {{insurance_name}}',
		COVERAGE_DETAIL_PAGE_SUB_TITLE:
			'Selecciona la cotización que tenga sentido para tu empresa:',
		COVERAGE_DETAIL_PAGE_BANNER_TITLE: '¿Qué es el seguro {{insurance_name}} ?',
		COVERAGE_DETAIL_PAGE_BANNER_SUB_TITLE: '',
		COVERAGE_DETAIL_PAGE_BANNER_MORE_INFO: '¿Quieres saber más?',
		COVERAGE_DETAIL_PAGE_BANNER_CLICK_INFO: ' Haz clic aquí',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGE_TEXT: 'Cobertura',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGE_SELECTED_TEXT:
			'La compensación máxima proporcionada por la aseguradora en caso de reclamo es de {{coverage_selected}}.',
		COVERAGE_DETAIL_PAGE_QUOTE_GROSS_TEXT: 'Prima bruta',
		COVERAGE_DETAIL_PAGE_QUOTE_EXPIRED_TEXT: 'Cotización expira en:',
		COVERAGE_DETAIL_PAGE_QUOTE_AMOUNT_TO_PAID_TEXT:
			'Monto a pagar por la cobertura',
		COVERAGE_DETAIL_PAGE_QUOTE_WITH_FEES_TEXT: 'con Impuesto incluido',
		COVERAGE_DETAIL_PAGE_QUOTE_WITH_OUT_FEES_TEXT: 'más impuestos',
		COVERAGE_DETAIL_PAGE_QUOTE_SELECT_TEXT: 'Seleccionar cotización',
		COVERAGE_DETAIL_PAGE_QUOTE_SELECTED_TEXT: 'Cotação selecionada',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGES_TEXT: 'Coberturas',
		COVERAGE_DETAIL_PAGE_QUOTE_EXCLUSIONS_TEXT: 'Exclusiones',
		COVERAGE_DETAIL_PAGE_QUOTE_MORE_TEXT: '+{{total_coverages}}',
		COVERAGE_DETAIL_PAGE_QUOTE_VIEW_MORE_DETAIL_TEXT: 'Ver más información',
		COVERAGE_DETAIL_PAGE_QUOTE_DOWNLOAD_FULL_COVERAGE_TEXT:
			'Descargar cotización completa',
		COVERAGE_DETAIL_PAGE_QUOTE_DO_YOU_NEED_HELP_TEXT:
			'¿Necesitas ayuda con las cotizaciones?',
		COVERAGE_DETAIL_PAGE_QUOTE_SPEAK_AN_EXPERT_TEXT: 'Habla con un experto',
		QUOTE_RECOMMENDED_TEXT: 'Recomendado',
		QUOTE_MODAL_MORE_INFO_TITLE: 'Información sobre el seguro',
		QUOTE_MODAL_COVERAGE_TITLE: 'Coberturas',
		QUOTE_MODAL_EXCLUSIONS_TITLE: 'Exclusiones',
		QUOTE_MODAL_PAYMENT_TITLE: 'Pago',
		QUOTE_MODAL_RETRO_ACTIVITY_TITLE: 'Retroactividad',
		QUOTE_MODAL_SCOPE_TITLE: 'Alcance de la cobertura',
		QUOTE_MODAL_SUSEP_CODE_TITLE: 'Código de seguro',
		QUOTE_MODAL_WE_NEED_TEXT:
			'Necesitamos obtener la firma de un representante legal de la empresa para iniciar el proceso de emisión.',
		QUOTE_MODAL_DO_YOU_WANT_TEXT: '¿Deseas confirmar la cotización?',
		QUOTE_MODAL_CONTRACT_CALL_TO_ACTION_TEXT: 'Contratar',
		QUOTE_MODAL_CANCEL_TEXT: 'Cancelar',
		QUOTE_SUCCESS_MODAL_TITLE: '¡Felicitaciones por tu elección!',
		QUOTE_SUCCESS_MODAL_INFO:
			'Enviaremos un correo electrónico a {{email}} para confirmar la información proporcionada y la cobertura seleccionada.',
		QUOTE_SUCCESS_MODAL_INTRO:
			'Después de la confirmación solicitada, iniciaremos el proceso de emisión en conjunto con la aseguradora. Si no se requiere ninguna documentación o información adicional, esperamos obtener la póliza en un plazo de 15 días.',
		EXPIRED: 'Expirada',
		REMOVE: 'Remover',
		QUOTE_PAGE_TITLE: 'Cotizaciones',
		QUOTE_PAGE_SUB_TITLE:
			'Verifica los presupuestos disponibles y sigue el estado de las cotizaciones. El estado se actualizará siempre que haya avances en la solicitud.',
		QUOTE_PAGE_BANNER_TITLE: '¿Necesitas ayuda con las cotizaciones?',
		QUOTE_PAGE_BANNER_CALL_TO_ACTION: 'Habla con un experto',
		QUOTE_BLOCK_SEARCHING_QUOTE_TITLE: 'Buscando cotización',
		QUOTE_BLOCK_AVAILABLE_QUOTES_TITLE: 'Cotizaciones disponibles',
		QUOTE_BLOCK_EMISSION_QUOTES_TITLE: 'Cotizaciones en emisión',
		QUOTE_BLOCK_EXPIRED_QUOTES_TITLE: 'Cotizaciones expiradas',
		QUOTE_CARD_PRODUCT_TITLE: 'Cotizaciones para el producto',
		QUOTE_CARD_APPLICATION_DATE_TEXT: 'Fecha de solicitud:',
		QUOTE_CARD_SEARCH_QUOTE_TEXT: 'Buscando una cotización',
		QUOTE_CARD_EXPIRATION_DATE_TEXT: 'Cotización expira el:',
		QUOTE_CARD_VIEW_DETAIL_LINK: 'Ver cotizaciones',
		QUOTE_CARD_INSURER_TEXT: 'Compañía de seguros:',
		QUOTE_CARD_MAXIMUM_COVERAGE_TEXT:
			'Monto máximo de cobertura en caso de siniestro',
		QUOTE_VALID_FOR: 'Cotizaciones válidas para:',
		EDIT: 'Editar',
		BACK_LINK: 'Volver',
		QUOTE_PAGE_DONT_HAVE_QUOTES_TEXT:
			'Actualmente no tenemos cotizaciones disponibles.',
		QUOTE_PAGE_START_YOUR_QUOTE_TEXT:
			'Inicia tu proceso de cotización ahora mismo.',
		QUOTE_PAGE_QUOTE_TEXT_BUTTON: 'Cotizar ahora',
		IPAF_STATUS_CLOSED: 'Finalizado',
		SIGN_IN_TEXT: 'Ingresar',
		POLICIES_PAGE_MENU: 'Mis pólizas',
		POLICIES_PAGE_TITLE: 'Mis pólizas',
		POLICIES_PAGE_SUB_TITLE:
			'Visualiza y administra las pólizas contratadas por tu empresa',
		TAB_POLICY_ACTIVE: 'Pólizas activas',
		TAB_POLICY_EXPIRED: 'Pólizas vencidas',
		PREAPP_LIST_ITEM_1:
			'Regístrate para crear tu cuenta y comenzar el proceso de cotización.',
		PREAPP_LIST_ITEM_2: 'Gestiona todo lo relacionado con tu seguro con Latú.',
		ALREADY_ACCOUNT_TEXT: ' ¿Ya tienes una cuenta?',
		ALREADY_ACCOUNT_TEXT_LINK: 'Inicia sesión',
		PAID: 'Pagado',
		PENDING: 'Pendiente',
		LATE: 'Atrasado',
		DELAYED: 'Atrasado',
		IN_QUEUE: 'Pendiente',
		POLICY_CARD_POLICY_HOLDER: 'Tomador del seguro',
		POLICY_CARD_INSURANCE_COMPANY: 'Aseguradora',
		POLICY_CARD_INSURANCE_EXPIRATION: 'Vencimiento',
		POLICY_CARD_VIEW_POLICY_TEXT: 'Ver poliza',
		POLICY_DETAIL_GENERAL_INFORMATION_TITLE: 'Información general',
		POLICY_DETAIL_INSURANCE_NAME_TITLE: 'Sobre {{insurance_name}}',
		POLICY_DETAIL_COVERAGES_AND_EXCLUSIONS_TITLE: 'Coberturas y exclusiones',
		POLICY_DETAIL_COVERAGE_TITLE: 'Coberturas del seguro',
		POLICY_DETAIL_COVERAGE_EXCLUSIONS_TITLE: 'Exclusiones del seguro',
		POLICY_DETAIL_DOWNLOAD_POLICY: 'Ver más detalles de la póliza',
		POLICY_DETAIL_DETAIL_POLICY: 'Ver más detalles de la póliza',
		POLICY_DETAIL_COVERAGE_LIMIT: 'Límite de cobertura',
		POLICY_DETAIL_TOTAL_COVERAGE: 'Cobertura total',
		POLICY_DETAIL_SUB_LIMITS_TITLE: '¡Presta atención a los sublímites!',
		POLICY_DETAIL_SUB_LIMITS_TEXT:
			'Los sublímites restringen el valor máximo de cobertura para ciertos riesgos o daños. Para obtener más información, por favor verifica tu póliza.',
		POLICY_DETAIL_MAX_COVERAGE_INFO:
			'Valor máximo cubierto en caso de siniestro',
		POLICY_DETAIL_PERIOD_INFO: 'Vigencia',
		POLICY_DETAIL_EFFECTIVE_DATE: 'Fecha de vigencia',
		POLICY_START_AND_END_DATE:
			'Fecha de inicio y fin de la vigencia de la póliza',
		POLICY_DETAIL_PLAN_ANNUAL: 'Plan anual',
		POLICY_DETAIL_PAYMENT_TITLE: 'Pago',
		POLICY_DETAIL_PAYMENT_SUB_TITLE:
			'Realice un seguimiento de sus pagos de seguro.',
		POLICY_DETAIL_TOTAL_AMOUNT_BE_PAID: 'Monto total a pagar:',
		POLICY_DETAIL_PAYMENT_TYPE: 'Método de pago:',
		POLICY_DETAIL_NEXT_PAYMENT: 'Próximo pago el:',
		POLICY_TABLE_INVOICE_TITLE: 'Facturas',
		POLICY_TABLE_EXPIRATION_TITLE: 'Fecha de vencimiento',
		POLICY_TABLE_VALUE_TITLE: 'Monto',
		POLICY_TABLE_DOWNLOAD_TITLE: 'Descargar',
		POLICY_DETAIL_PAYMENT_STATUS_INFO:
			'El estado de pago se actualiza semanalmente.',
		POLICY_DETAIL_REPORT_CLAIM_TEXT_A: '¿Necesitas informar un siniestro? ',
		POLICY_DETAIL_REPORT_CLAIM_TEXT_B: '¡Estamos aquí para ayudarte!',
		POLICY_DETAIL_REPORT_CLAIM_LINK: 'Informar un siniestro',
		COVERAGE_DETAIL_PAGE_POLICY_DOWNLOAD_FULL_COVERAGE_TEXT: 'Descargar poliza',
		POLICY_DETAIL_DATA_ZERO_TEXT:
			'Estamos trabajando para traer tus datos de pago. ¡Pronto podrás seguirlos aquí!',
		SELECTED_QUOTE_TEXT: 'Cotización seleccionada:',
		CLOSE_AND_REDIRECT_QUOTES_HOME: 'Ir al menú de cotizaciones',
		COMPANY_STRUCTURE_ADD_BUTTON_TEXT: 'Agregar empresa',
		COMPANY_STRUCTURE_INFO_TEXT: 'Puede agregar más de un cliente',
		COMPANY_REVENUE_DISTRIBUTION_INFO_TEXT: 'Puede agregar más de una persona',
		COMPANY_REVENUE_INDUSTRY_PERCENTAGE_INFO_TEXT:
			'Solo complete los que apliquen a su negocio',
		COMPANY_REVENUE_PERCENTAGE_INFO_TEXT:
			'Solo complete los que apliquen a su negocio',
		ADD_COMPANY_MEMBERS_TEXT: 'Añadir miembros de la empresa',
		ADD_COMPANY_TEXT: 'Agregar empresa',
		EDIT_COMPANY_TEXT: 'Editar empresa',
		BANNER_PROGRESS_IPAF_TITLE: '¡Tienes un formulario en progreso!',
		BANNER_PROGRESS_IPAF_TEXT:
			'Completa el formulario para recibir tu cotización.',
		BANNER_PROGRESS_IPAF_CALL_TO_ACTION: 'Completar formulario',
		UNAVAILABLE_TEXT: 'No disponible:',
		PURCHASE_INSURANCE_TITLE: 'Adquirir un seguro',
		PURCHASE_INSURANCE_TEXT:
			'Inicia el proceso de adquirir tu seguro de forma rápida y fácil.',
		AVAILABLE_QUOTES_TITLE: 'Ver cotizaciones disponibles',
		AVAILABLE_QUOTES_TEXT: '¡Mira las cotizaciones disponibles en Latú!',
		AVAILABLE_QUOTES_UNAVAILABLE_TEXT:
			'Pronto tendrás acceso a las cotizaciones de tu seguro.',
		AVAILABLE_POLICY_TITLE: 'Ver pólizas disponibles',
		AVAILABLE_POLICY_TEXT: 'Verifica tus pólizas y el estado de pago de ellas.',
		AVAILABLE_POLICY_UNAVAILABLE_TEXT:
			'Podrás ver tus pólizas una vez que tu seguro esté activo.',
		VIEW_QUOTES_TEXT: 'Ver cotizaciones',
		VIEW_POLICY_TEXT: 'Ver pólizas',
		ACTIVE_TAG_POLICY_COPY: 'Vigencia activa',
		CREATED_TAG_POLICY_COPY: 'Activación el {{startDate}}',
		EXPIRED_TAG_POLICY_COPY: 'Vigencia expirada',
		PENDING_PAYMENT_TAG_POLICY: 'Activación pendiente de pago inicial',
		FORM_ADD_COMPANY_TITLE: 'Agregar empresa',
		CLAIMS_DETAIL_TITLE_PAGE: 'Siniestro',
		CLAIMS_PAGE_MENU: 'Siniestros',
		CLAIMS_TITLE_PAGE: 'Siniestros',
		CLAIMS_SUBTITLE_PAGE:
			'Visualiza los siniestros que tienes abiertos y sigue el estado de cada uno.',
		CLAIMS_CTA_TITLE: 'Comunicar un siniestro.',
		CLAIMS_CTA_SUBTITLE:
			'Completa los datos del siniestro para que podamos ayudarte.',
		CLAIMS_TABLE_TITLE: 'Siniestros por estado.',
		CLAIMS_TABLE_SUBTITLE: 'Sigue el estado de tus siniestros comunicados.',
		CLAIMS_TABLE_PROTOCOL: 'Nº de protocolo.',
		CLAIMS_TABLE_TYPE: 'Tipo de siniestro.',
		CLAIMS_TABLE_UPDATE: 'Última actualización',
		CLAIMS_TABLE_DOWNLOAD: 'Ver siniestro',
		CLAIMS_CREATE_TITLE: 'Comunicar siniestro.',
		CLAIMS_CREATE_SUBTITLE: 'Por favor, complete la siguiente información:',
		CLAIMS_CREATE_Mandatory: 'Campos obligatorios',
		CLAIMS_CREATE_TYPE:
			'Seleccione el seguro del cual desea comunicar el siniestro:',
		CLAIMS_CREATE_SELECT: 'Seleccione',
		CLAIMS_CREATE_SHORT_DESCRIPTION: 'Descripción del incidente:',
		CLAIMS_CREATE_CONTACT_NAME: 'Nombre completo:',
		CLAIMS_CREATE_CONTACT_NAME_TEXT: 'Ingrese su nombre completo:',
		CLAIMS_CREATE_CONTACT_EMAIL: 'E-mail:',
		CLAIMS_CREATE_CONTACT_EMAIL_TEXT: 'Ingrese un correo electrónico válido:',
		CLAIMS_CREATE_CONTACT_TELEPHONE: 'Proporciónenos su número de contacto:',
		CLAIMS_CREATE_CONTACT_TELEPHONE_TEXT: 'Ingrese su número de celular:',
		CLAIMS_CREATE_CTA: 'Abrir siniestro',
		CLAIMS_DATA_ZERO_TEXT:
			'No encontramos un seguro activo asociado a su cuenta en este momento. Una vez que adquiera un seguro con nosotros, estaremos listos para ayudar en caso de cualquier siniestro.',
		CLAIMS_STATUS_PENDING: 'En progreso',
		CLAIMS_STATUS_IN_PROGRESS: 'En progreso',
		CLAIMS_STATUS_REJECTED: 'Cerrado',
		CLAIMS_STATUS_APPROVED: 'Aprobado',
		CLAIMS_DETAILS_SUB_TITLE: 'Detalles del siniestro',
		CLAIMS_DETAIL_FULL_NAME: 'Nombre completo',
		CLAIMS_DETAIL_PHONE_CONTACT: 'Teléfono de contacto',
		CLAIMS_DETAIL_EMAIL: 'Email',
		CLAIMS_DESCRIPTION_INCIDENT: 'Descripción del incidente',
		CLAIMS_DESCRIPTION_UPDATES_SUBTITLE: 'Actualizaciones ',
		SUCCESS_SCREEN_TITLE: 'Su siniestro ha sido comunicado.',
		SUCCESS_SCREEN_SUBTITLE:
			'Hemos recibido su solicitud. Por favor, espere mientras la analizamos; nos pondremos en contacto con usted lo antes posible.',
		SUCCESS_SCREEN_PRODUCT_TITLE: 'Producto',
		SUCCESS_SCREEN_SUMMARY: 'Resumen del siniestro',
		SUCCESS_SCREEN_VIEW_CLAIM: 'Ver siniestro',
		SUCCESS_SCREEN_GO_BACK: 'Ir a la página de inicio',
		FOOTER_SUPPORT: 'Soporte',
		FOOTER_SCHEDULE_INFO: 'Agendar una reunión',
		TOOLTIP_TITLE_SUBLIMITS: 'Sobre el sublímite',
		TOOLTIP_INFO_SUBLIMITS:
			'Límite máximo dentro de la póliza de seguro para coberturas específicas.',
		TOOLTIP_INFO_FRANQUIA:
			'Representa la cantidad de dinero que el titular de la póliza debe pagar de su propio bolsillo antes de que entre en vigor su cobertura de seguro.',
		BUBBLE_WHATSAPP_INFO: 'Contáctanos a través de WhatsApp',
		BUBBLE_SCHEDULE_MEET_INFO: 'Agendar una reunión',
		USER_DISABLED: 'Activo',
		USER_ENABLED: 'Inactivo',
		USER_PENDING: 'Pendiente',
		ROL_COPY_ADMIN: 'Administrador',
		ROL_COPY_BROKER: 'Administrador',
		ROL_COPY_BROKER_INVITED: 'Miembro del equipo',
		ROL_COPY_BROKER_CUSTOMER: 'Administrador',
		ROL_COPY_USER: 'Miembro del equipo',
		REQUIRED_NAME: 'El nombre es requerido',
		REQUIRED_EMAIL: 'El email es requerido',
		INVALID_EMAIL: 'El formato del email es invalido',
		MENU_NAME: 'Miembros del equipo',
		ROLES_TITLE: 'Miembros del equipo',
		ROLES_SUBTITLE:
			'Invita o gestiona a los compañeros de trabajo de tu equipo',
		ROLES_MAIN_CTA: 'Invitar miembros',
		ACCOUNT_OWNERSHIP: 'Administrador de la cuenta',
		ACCOUNT_OWNERSHIP_DISCLAIMER_1: 'Para cambiar al',
		ACCOUNT_OWNERSHIP_DISCLAIMER_2: 'administrador,',
		ACCOUNT_OWNERSHIP_DISCLAIMER_3: 'ponte en contacto con soporte',
		PENDING_INVITATIONS_COPY: 'Invitaciones Pendientes',
		USER_NAMES: 'Nombre completo',
		USER_EMAIL: 'Correo electrónico',
		USER_ROLE: 'Permisos',
		USER_ACTIONS: 'Acción posible',
		RE_SEND_INVITATION_BUTTON: 'Reenviar invitación',
		ADMIN_ROLE: 'Administrador',
		TEAM_MEMBER_ROLE: 'Miembro del equipo',
		REMOVE_USER_TITLE:
			'¿Estás seguro de que deseas eliminar a este miembro del equipo?',
		REMOVE_USER_SUBTITLE_1: 'El usuario',
		REMOVE_USER_INVITE_SUBTITLE_1:
			'El invitado con la dirección de correo electrónico',
		REMOVE_USER_SUBTITLE_2:
			'ya no tendrá acceso a la cuenta de Latú. Sin embargo, podrás agregar al usuario nuevamente cuando lo desees',
		REMOVE_USER_INVITE_SUBTITLE_2:
			'ya no tendrá una invitación pendiente a la cuenta de Latú. No te preocupes, puedes enviar una nueva invitación cuando quieras.',
		REMOVE_USER_QUESTION: '¿Deseas eliminar al usuario?',
		REMOVE_USER_INVITE_QUESTION: '¿Quieres eliminar a este invitado?',
		REMOVE_USER_CONFIRM: 'Eliminar usuario',
		REMOVE_USER_CANCEL: 'Cancelar',
		REMOVE_USER_SUCCESS_1: '¡El usuario',
		REMOVE_USER_SUCCESS_2: 'ha sido eliminado con éxito!',
		ADD_VIEW_TITLE: 'Invitar a miembros del equipo',
		ADD_VIEW_SUBTITLE:
			'Elige uno o más miembros para componer tu equipo a través de su nombre y correo electrónico.',
		ADD_VIEW_SUCCESS_TITLE: '¡Miembros invitados con éxito!',
		ADD_VIEW_SUCCESS_SUBTITLE:
			'Enviaremos un correo electrónico a todos los miembros añadidos para que puedan acceder de inmediato a la plataforma de Latú Corretores',
		ADD_VIEW_SUCCESS_SUBTITLE_TO_USER:
			'Enviaremos un correo electrónico a todos los miembros añadidos para que puedan acceder de inmediato a la plataforma de Latú Seguros',
		ADD_VIEW_NAME_TITLE: 'Nombre',
		ADD_VIEW_NAME_PLACEHOLDER: 'Ingresa un nombre válido',
		ADD_VIEW_TEAM_EMAIL: 'email',
		ADD_VIEW_EMAIL_TITLE: 'Email',
		ADD_VIEW_EMAIL_PLACEHOLDER: 'Ingresa un email válido',
		ADD_VIEW_EMAIL_ROLE: 'Miembro del equipo',
		ADD_VIEW_ADD_MORE: 'Agregar miembro',
		ADD_VIEW_CONFIRM_CTA: 'Invitar miembro',
		ADD_VIEW_CONFIRM_CTA_MANY: 'Invitar {{numMembers}} miembros',
		ADD_VIEW_CANCEL: 'Cancelar',
		ADD_VIEW_SUCCESS_CTA: 'Entendido',
		ADD_VIEW_SUCCESS_MESSAGE: 'Invitación enviada con éxito',
		ADD_VIEW_BACK_BUTTON: 'Volver',
		ADD_VIEW_NO_ACCESS:
			'Lo siento - Tu nivel de acceso actual no te permite invitar a personas.',
		REGISTER_SCREEN_TITLE: '¡Bienvenido a Latú!',
		REGISTER_SCREEN_SUBTITLE: 'Ingresa tus datos para crear una cuenta',
		REGISTER_SCREEN_ACCOUNT_INFO_TITLE: 'Información de la cuenta',
		REGISTER_SCREEN_ACCOUNT_INFO_EMAIL: 'Dirección de correo electrónico',
		REGISTER_SCREEN_ACCOUNT_INFO_COMPANY: 'Equipo/Organización',
		REGISTER_SCREEN_ACCOUNT_INFO_GOOGLE_LOGIN: 'Continuar con Google',
		REGISTER_SCREEN_ACCOUNT_OPTION_TEXT:
			'o inicia sesión con correo electrónico',
		REGISTER_SCREEN_ACCOUNT_USERNAME: 'Nombre completo',
		REGISTER_SCREEN_ACCOUNT_USERNAME_PLACEHOLDER: 'Ingresa tu nombre completo',
		REGISTER_SCREEN_ACCOUNT_PASSWORD: 'Crea tu contraseña',
		REGISTER_SCREEN_ACCOUNT_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
		REGISTER_SCREEN_ACCOUNT_TERMS_CONDITIONS: 'Acepto los Términos de Servicio',
		REGISTER_SCREEN_ACCOUNT_CTA: 'Registrarme',
		WELCOME_SCREEN_TITLE: '¡Bienvenido a la App de Latú!',
		WELCOME_SCREEN_SUBTITLE:
			'Dentro de este hub, podrás ver tus pólizas comerciales, explorar cotizaciones y gestionar reclamos. Es tu destino único para todo lo relacionado con seguros, poniéndote al mando como nunca antes.',
		WELCOME_SCREEN_CTA: 'Entendido',
		BANNER_PROGRESS_RENEWAL_IPAF_TITLE: '¡Tienes pólizas a punto de vencer!',
		BANNER_PROGRESS_RENEWAL_IPAF_TEXT:
			'Renueva tus pólizas y mantén segura tu empresa.',
		BANNER_PROGRESS_RENEWAL_IPAF_CALL_TO_ACTION: 'Renovar póliza',
		INFO_PERCENT_DEDUCTIBLE: 'de las pérdidas',
		INFO_NO_DEDUCTIBLE: 'Seguro sin deducible',
		INFO_NO_DEDUCTIBLE_TEMP:
			'10% de las pérdidas, con un mínimo de R$ 250,000.00',
		FRANQUIA_TITLE: 'Deducible (se aplica a cualquier reclamo)',
		FRANQUIA_DEFINITION:
			'Cantidad a pagar antes de que se proporcione la cobertura.',
		MINIMUM_OF: 'Mínimo de',
		REGULATORY_DISCLAIMER:
			'Para una descripción y lista completa de las coberturas, exclusiones y definiciones generales, por favor refiérase a las Condiciones Generales del Producto.',
		REGULATORY_DISCLAIMER_LINK: 'Descargar condiciones generales.',
		INTRODUCTION_RENEWALS_MANTRA_A: 'Bienvenido al proceso de',
		INTRODUCTION_RENEWALS_MANTRA_B: 'renovación',
		INTRODUCTION_RENEWALS_MANTRA_C: 'del seguro.',
		INTRODUCTION_RENEWALS_TITLE_A:
			'Para renovar tus pólizas de seguro, necesitamos',
		INTRODUCTION_RENEWALS_TITLE_B: 'actualizar tu información.',
		INTRODUCTION_RENEWALS_TITLE_C: 'No te preocupes,',
		INTRODUCTION_RENEWALS_TITLE_D:
			'el proceso de recopilación de información es completamente simplificado.',
		INTRODUCTION_RENEWALS_SUBTITLE_PRODUCTS:
			'Pólizas de seguros que están por renovar:',
		INTRODUCTION_RENEWALS_SLIDER_TITLE:
			'¿Cómo funciona el proceso de renovación?',
		INTRODUCTION_RENEWALS_SLIDER_STEP1_TITLE:
			'Simplificando el proceso para ti:',
		INTRODUCTION_RENEWALS_SLIDER_STEP1_TEXT:
			'Hemos actualizado la aplicación para simplificar la presentación de información, con la mayoría de los detalles ya prellenados. Nuestro equipo utilizará esta información para proponer la mejor renovación para su negocio.',
		INTRODUCTION_RENEWALS_SLIDER_STEP2_TITLE:
			'Análisis de la nueva información y presentación de la propuesta.',
		INTRODUCTION_RENEWALS_SLIDER_STEP2_TEXT:
			'Presentamos una propuesta completamente adaptada, que incluye coberturas, límites, condiciones y primas. Una vez que elija la propuesta ideal, comenzaremos a emitir la póliza y los documentos de pago. Estaremos disponibles para aclarar y garantizar su plena comprensión de la propuesta.',
		INTRODUCTION_RENEWALS_SLIDER_STEP3_TITLE: '¡Póliza renovada!',
		INTRODUCTION_RENEWALS_SLIDER_STEP3_TEXT:
			'Después de completar todos los procedimientos, podrá acceder a su póliza actualizada directamente a través de la aplicación.',
		INTRODUCTION_RENEWALS_REMINDER_TEXT_A: 'Recordatorio:',
		INTRODUCTION_RENEWALS_REMINDER_TEXT_B:
			'Antes de que expire alguna de sus pólizas actuales, nuestro equipo le notificará.',
		INTRODUCTION_RENEWALS_START_BUTTON: 'Iniciar renovación',
		REVIEW_ANSWER_TITLE:
			'Revise sus datos a continuación y crearemos su cotización.',
		REVIEW_ANSWER_QUESTION: 'Pregunta',
		REVIEW_ANSWER_ANSWER: 'Respuesta',
		REVIEW_ANSWER_EDIT: 'Editar',
		REVIEW_ANSWER_CONTINUE: 'Avanzar',
		NO_FILE_ANSWER: 'No se ha adjuntado ningún documento.',
		CYBER_MODULE_TIERS_LITE: 'Latú Cyber Lite',
		CYBER_MODULE_TIERS_PLUS: 'Latú Cyber Plus',
		CYBER_MODULE_SUBSCRIBE_INTRO_TITLE: 'Latú Scan',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_1:
			'Tome el control de su seguridad cibernética con Latú Scan, la principal herramienta de gestión de riesgos adoptada por organizaciones de todos los tamaños. Obtenga visibilidad de sus activos, identifique vulnerabilidades antes de posibles ataques y sepa cómo corregirlas.',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_2: 'control de tu ciberseguridad',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_3: 'con',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_4: 'Latú Sonar,',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_5:
			'la principal herramienta de gestión de riesgos adoptada por organizaciones de todos los tamaños. Obtén',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_6: 'visibilidad de tus activos,',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_7: 'identifica',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_8: 'vulnerabilidades',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_9: 'antes de posibles ataques y aprende',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_10: 'cómo abordarlas.',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_11:
			'Solicita tu primera evaluación ahora mismo.',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_12: 'Solicitar evaluación',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_TITLE: '¿Qué analizamos?',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_1:
			'Activos de datos (como dominios, IPs y todas las 65 mil puertas)',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_2: 'Aplicaciones y Servicios',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_3: 'Fugas de datos',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_4: 'Riesgos de phishing',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_BUTTON:
			'Mira el video de ciberseguridad.',
		CYBER_MODULE_SUBSCRIBE_FORM_TITLE:
			'Solicitar Evaluación de Ciberseguridad.',
		CYBER_MODULE_SUBSCRIBE_FORM_SUBTITLE:
			'Solo necesitamos algunos datos para realizar una evaluación adaptada a su negocio.',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN: 'Dominio principal',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN_DESCRIPTION_1: 'Nota:',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN_DESCRIPTION_2:
			'obtendremos todos los subdominios y direcciones IP asociadas con el dominio listado para la evaluación cibernética.',
		CYBER_MODULE_SUBSCRIBE_FORM_ACTIVITY: 'Actividad de la empresa.',
		CYBER_MODULE_SUBSCRIBE_FORM_COMPANY_SIZE: 'Número de empleados.',
		CYBER_MODULE_SUBSCRIBE_FORM_COMPANY_REVENUE: 'Ingresos del último año.',
		CYBER_MODULE_SUBSCRIBE_FORM_BUTTON: 'Solicitar evaluación.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_TITLE: '',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_TEXT:
			'Le notificaremos sobre el progreso de su Evaluación Cibernética por correo electrónico a',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BUTTON_REPORTS: 'Ir a mis informes.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BANNER_TITLE:
			'Ahora puedes contratar el Seguro Cibernético de Latú.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BANNER_SUBTITLE:
			'Has avanzado hacia la conformidad. ¡Descubre nuestro Seguro Cibernético y da otro paso hacia la ciberseguridad de tu empresa!',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BUTTON_QUOTE: 'Obtén tu cotización.',
		CYBER_MODULE_TALK_TO_LATU: 'Hablar con Latú',
		CYBER_MODULE_TIERS_DETAIL_TITLE: '¡Mejora tu ciberseguridad!',
		CYBER_MODULE_TIERS_DETAIL_SUBTITLE:
			'Consulta los planes disponibles a continuación:',
		CYBER_MODULE_TIERS_DETAIL_LITE_TAG: 'Paquete Actual',
		CYBER_MODULE_TIERS_DETAIL_LITE_TITLE: 'Latú Cyber Lite',
		CYBER_MODULE_TIERS_DETAIL_LITE_SUBTITLE:
			'Protección esencial para tu presencia digital.',
		CYBER_MODULE_TIERS_DETAIL_LITE_PRICE_TEXT: '¡Oferta por tiempo limitado!',
		CYBER_MODULE_TIERS_DETAIL_LITE_PERKS_1:
			'Evaluación trimestral de vulnerabilidades',
		CYBER_MODULE_TIERS_DETAIL_LITE_PERKS_2:
			'Lista de verificación de cumplimiento de ciberseguridad y LGPD',
		CYBER_MODULE_TIERS_DETAIL_PLUS_TAG: 'Recomendado',
		CYBER_MODULE_TIERS_DETAIL_PLUS_TITLE: 'Latú Cyber Plus',
		CYBER_MODULE_TIERS_DETAIL_PLUS_SUBTITLE:
			'Seguridad total y orientación de expertos.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_BUTTON_QUOTE: 'Obtén una cotización',
		CYBER_MODULE_TIERS_DETAIL_PLUS_BUTTON_BOOK:
			'El precio de este plan es personalizado. Póngase en contacto con Latú.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_1:
			'Todo lo que está incluido en el plan Lite.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_2: 'Protección de Seguro Cibernético.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_3:
			'Evaluación de Vulnerabilidad Mensual.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_4: 'Simulación y Pruebas de Phishing.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_5:
			'Acceso a Expertos en Ciberseguridad.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_6:
			'Gestión de Respuesta a Incidentes, 24/7.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_7:
			'Firewall, Antivirus y Respaldo de Datos incluidos de forma gratuita.',
		CYBER_MODULE_CONTACT_BANNER_TITLE:
			'¿Cómo le gustaría ponerse en contacto con nuestro equipo?',
		CYBER_MODULE_CONTACT_BANNER_SUBTITLE:
			'Estamos aquí para ayudarte. Elija la mejor forma de contactarnos:',
		CYBER_MODULE_REPORT_TITLE: 'Evaluación Cibernética.',
		CYBER_MODULE_REPORT_SUBTITLE: 'Historial de evaluaciones de ciberseguridad',
		CYBER_MODULE_REPORT_TEXT_1:
			'Acceda a los informes generados a partir de las evaluaciones realizadas por',
		CYBER_MODULE_REPORT_TEXT_2: 'Latú Sonar.',
		CYBER_MODULE_REPORT_BANNER_TITLE: 'Recursos analizados.',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_1: 'Tiene una',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_2: 'evaluación en curso',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_3:
			'Pronto, podrá ver los recursos analizados.',
		CYBER_MODULE_REPORT_COLUMN_DATE: 'Fecha del informe.',
		CYBER_MODULE_REPORT_COLUMN_SCORE: 'Puntuación de la empresa.',
		CYBER_MODULE_REPORT_COLUMN_VULNERABILITIES: 'Número de vulnerabilidades.',
		CYBER_MODULE_REPORT_COLUMN_DISCLAIMER:
			'Si deseas cancelar las evaluaciones periódicas, contáctenos.',
		CYBER_MODULE_REPORT_COLUMN_RISK_LOW: 'Bajo riesgo',
		CYBER_MODULE_REPORT_COLUMN_RISK_MEDIUM: 'Riesgo medio',
		CYBER_MODULE_REPORT_COLUMN_RISK_HIGH: 'Alto riesgo',
		CYBER_MODULE_REPORT_COLUMN_VULNERABILITIES_LABEL: 'vulnerabilidades',
		CYBER_MODULE_REPORT_COLUMN_UNDER_REVIEW: 'En análisis',
		CYBER_PAGE_MENU: 'Evaluación Cibernética',
		ANNUAL_REVENUE_OPTION_1: 'Menos de R$ 250.000',
		ANNUAL_REVENUE_OPTION_2: '250.000 - R$ 1.000.000',
		ANNUAL_REVENUE_OPTION_3: 'R$ 1.000.000 - R$ 5.000.000',
		ANNUAL_REVENUE_OPTION_4: 'Más de R$ 5.000.000',
		COMPANY_ACTIVITY_OPTION_1: 'Salud',
		COMPANY_ACTIVITY_OPTION_2: 'Servicios Financieros',
		COMPANY_ACTIVITY_OPTION_3: 'Manufactura',
		COMPANY_ACTIVITY_OPTION_4: 'Otros',
		CAPITAL_RAISED: 'Capital Levantado',
		FINANCING_OBTAINED: 'Financiamento Obtido',
		ADDITIONAL_INSTRUCTIONS_SECTION_TITLE: 'Instrucciones adicionales',
		ADDITIONAL_INSTRUCTIONS_SECTION_SUBTITLE:
			'Si tienes instrucciones adicionales, por favor utiliza el campo de abajo:',
		ADDITIONAL_INSTRUCTIONS_SECTION_PLACEHOLDER: 'Escribe aquí.',
		ADDITIONAL_INSTRUCTIONS_SECTION_BUTTON: 'Finalizar',
		ADDITIONAL_INSTRUCTIONS_MODAL_TITLE: '¡Información sobre tu presupuesto!',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_1: 'Notamos que agregaste',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_2: 'instrucciones adicionales',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_3:
			'en la solicitud de seguro. Sin embargo, eres elegible para recibir una cotización automatizada. Por favor,',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_4:
			'revisa la cotización proporcionada;',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_5:
			'si no cumple con tus instrucciones específicas, no te preocupes,',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_6:
			'nuestro equipo se pondrá en contacto contigo pronto.',
		ADDITIONAL_INSTRUCTIONS_MODAL_BUTTON: 'Entendi',
		NDA_CTA: 'Haga clic aquí para descargar nuestro NDA.',
		USER_TYPE_SELECTION_PAGE_TOOLTIP: '---',
		TAX_ID_FIELD_TOOLTIP_INFO: 'Los campos activos se pueden editar.',
		TAX_ID_FIELD_COMPANY_NAME_LABEL: 'Nombre de la empresa:',
		TAX_ID_FIELD_COMPANY_CREATION_DATE_LABEL:
			'¿Cuándo comenzó la empresa sus operaciones?',
		TAX_ID_FIELD_COMPANY_ADDRESS_TITLE: 'Dirección de la empresa',
		TAX_ID_FIELD_COMPANY_ADDRESS_STREET_LABEL: 'Calle',
		TAX_ID_FIELD_COMPANY_ADDRESS_CITY_LABEL: 'Ciudad',
		TAX_ID_FIELD_COMPANY_ADDRESS_NUMBER_LABEL: 'Número',
		TAX_ID_FIELD_COMPANY_ADDRESS_STATE_LABEL: 'Estado',
		TAX_ID_FIELD_COMPANY_ADDRESS_DETAIL_LABEL: 'Complemento',
		TAX_ID_FIELD_COMPANY_ADDRESS_ZIP_CODE_LABEL: 'Código postal',
		TAX_ID_FIELD_COMPANY_ADDRESS_NEIGHBORHOOD_LABEL: 'Barrio',
		BROKER_POLICY_ISSUED: 'Visualizar apólice',
		BROKER_IPAF_IN_PROGRESS: 'Formulário em andamento',
		BROKER_IPAF_EXPIRED: 'Formulário expirado',
		BROKER_QUOTING_IN_PROGRESS: 'Trabalhando em cotação',
		BROKER_QUOTE_AWAITING_SELECTION: 'Cotação pendente de seleção',
		BROKER_QUOTE_EXPIRED: 'Cotação expirou',
		BROKER_QUOTE_REJECTED: 'Cotação não foi aceita',
		BROKER_REJECTED: 'Cotação não foi aceita',
		BROKER_ISSUING_POLICY: 'Elaborando a apólice',
		BROKER_POLICY_EXPIRED: 'Apólice vencida',
		BROKER_POLICY_PENDING_PAYMENT: 'Pagamento do seguro pendente',
		BROKER_POLICY_TO_RENEW: 'Renove a apólice',
		BROKER_POLICY_PENDING_SIGNATURE: 'Assinatura pendente',
		BROKER_MONTH_SLIDER_RECEIVED: 'NF recebida',
		BROKER_MONTH_SLIDER_PENDING: 'NF pendente',
		BROKER_MONTH_SLIDER_OPEN: 'Em aberto',
		BROKER_MOVEMENT_DELAYED: 'Atrasado',
		BROKER_MOVEMENT_PAID: 'Pago',
		BROKER_MOVEMENT_PENDING: 'Aguardando',
		BROKER_FISCAL_NOTE_APPROVED: 'Aprovado',
		BROKER_FISCAL_NOTE_PENDING: 'NF pendente',
		BROKER_FISCAL_NOTE_WAITING_APPROVAL: 'Em revisão',
		BROKER_FISCAL_NOTE_NEED_ACTION: 'NF pendente',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_TITLE:
			'¿Listo para finalizar tu cuestionario?',
		ONE_PAGE_IPAF_MODAL_ONE_ACTION: 'Finalizar cuestionario',
		ONE_PAGE_IPAF_MODAL_SECOND_ACTION: 'Revisar datos',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_SUBTITLE:
			'Revisa cuidadosamente tus respuestas ahora para evitar futuros retrasos en el proceso de cotización.',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_BUTTON: 'Confirmar y continuar',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_CANCEL: 'Revisar las Respuestas',
		ONE_PAGE_FINISH: 'Finalizar',
		ONE_PAGE_NEXT: 'Guardar y continuar',
		SHARE_IPAF_BUTTON: 'Compartir',
		ONE_PAGE_ANSWERS_PENDING_INFO:
			'Hay preguntas pendientes que deben ser respondidas antes de que podamos proporcionar una cotización de seguro para su empresa. Por favor, respóndalas antes de continuar.',
		DATA_CAPITAL_RAISED_A: 'Capital Recaudado',
		DATA_CAPITAL_RAISED_B: 'Deuda Levantada',
		PENDING_PAYMENT_BANNER_TITLE: '¡No olvides realizar el pago de tu seguro!',
		PENDING_PAYMENT_BANNER_INFO:
			'La póliza estará activa solo después del pago de la primera cuota.',
		PAY_NOW: 'Pagar la factura actual.',
		INVALID_TAX_ID: 'Identificación fiscal inválida',
		EMPLOYS_TAG_FULL_TIME: 'Tiempo completo',
		EMPLOYS_TAG_HALF_TIME: 'Medio tiempo',
		EMPLOYS_TAG_THIRD_TIME: 'Subcontratado',
		COMPANY_SHAREHOLDER_ADD_BUTTON_TEXT: 'Agregar clientes',
		SHAREHOLDER_NAME_LABEL: 'Nombre del accionista',
		SHAREHOLDER_NAME_PLACEHOLDER: 'Nombre del cliente',
		SHAREHOLDER_PERCENTAGE_LABEL: '% de distribución',
		SHAREHOLDER_BUTTON_TO_ADD: 'Añadir uno más',
		SHAREHOLDER_BUTTON_TO_SAVE: 'Guardar datos',
		COMPANY_SHAREHOLDER_EDIT_TEXT: 'Editar',
		INDICATE_BILLING_PERCENTAGE_BUTTON: 'Indicar el porcentaje de facturación',
		INDICATE_INDUSTRY_CUSTOMERS: 'Indicar las actividades de tus clientes',
		LIST_ACTIVITY_DATA_PROCESSING: 'Procesamiento de Datos',
		LIST_ACTIVITY_SOFTWARE_DEVELOPMENT_INTERNAL:
			'Desarrollo de Software (específico)',
		LIST_ACTIVITY_SOFTWARE_DEVELOPMENT_EXTERNAL:
			'Desarrollo de Software (Paquete)',
		LIST_ACTIVITY_CONSULTING_PLANNING: 'Consultoría / Planificación',
		LIST_ACTIVITY_SYSTEM_INSTALLATION_MAINTENANCE:
			'Instalación / Mantenimiento de Sistemas',
		LIST_ACTIVITY_WEBSITE_DEVELOPMENT_DESIGN_MAINTENANCE:
			'Desarrollo, diseño y mantenimiento de sitios web',
		LIST_ACTIVITY_WEB_HOSTING: 'Alojamiento Web',
		LIST_ACTIVITY_E_COMMERCE: 'Comercio Electrónico',
		LIST_ACTIVITY_TRAINING_EDUCATIONAL_SERVICES:
			'Capacitación / Servicios educativos',
		LIST_ACTIVITY_PAYMENT_PROCESSING: 'Procesamiento de pagos',
		LIST_ACTIVITY_HARDWARE_DEVELOPMENT: 'Desarrollo de Hardware',
		LIST_ACTIVITY_HARDWARE_MAINTENANCE: 'Mantenimiento de Hardware',
		LIST_ACTIVITY_OTHERS: 'Otros',
		BUTTON_SAVE_ACTIVITIES: 'Guardar datos',
		COPY_ERROR_SUM_MUST_BE_100: 'La suma no puede superar el 100%',
		LIST_ROLES_FOUNDER: 'Fundador',
		LIST_ROLES_C_LEVEL_EXECUTIVE: 'Ejecutivo de nivel C',
		LIST_ROLES_DIRECTOR: 'Director',
		LIST_ROLES_MANAGER: 'Gerente',
		LIST_ROLES_SPECIALIST_ANALYST: 'Especialista / analista',
		LIST_ROLES_OTHER: 'Otro',
		LIST_DEGREES_MASTERS: 'Maestría',
		LIST_DEGREES_HIGHER_EDUCATION_COMPLETED: 'Educación superior completa',
		LIST_DEGREES_HIGH_SCHOOL: 'Secundaria',
		LIST_DEGREES_TECHNICAL_COURSE: 'Curso técnico',
		LIST_DEGREES_OTHER: 'Otro',
		REVENUE_SECTION_TITLE_1: 'Nombre completo',
		REVENUE_SECTION_PLACEHOLDER_1: 'Escriba el nombre completo',
		REVENUE_SECTION_TITLE_2: 'Cargo',
		REVENUE_SECTION_PLACEHOLDER_2: 'Seleccione el cargo',
		REVENUE_SECTION_TITLE_3: 'Formación académica',
		REVENUE_SECTION_PLACEHOLDER_3: 'Seleccione formación académica',
		REVENUE_BUTTON_ADD: 'Añadir uno más',
		REVENUE_BUTTON_SAVE: 'Guardar datos',
		REVENUE_SECTION_ERROR_1: 'El nombre completo es obligatorio',
		REVENUE_SECTION_ERROR_2: 'El cargo es obligatorio',
		REVENUE_SECTION_ERROR_3: 'La formación académica es obligatoria',
		EDUCATION_LABEL: 'Formación',
		COMPANY_STRUCTURE_DOCUMENT_LABEL: 'Identificación',
		COMPANY_STRUCTURE_OPERATIONAL_LABEL: 'Operacional',
		SELECTED_LABEL: 'Seleccionados',
		REGISTER_CHILD_USER_PLACEHOLDER_FIRST_NAME: 'Nombre',
		REGISTER_CHILD_USER_PLACEHOLDER_LAST_NAME: 'Apellido',
		ERROR_AUTH_PAGE_TITLE: '¡Vaya, se encontró un error!',
		ERROR_AUTH_PAGE_INTRO:
			'Nos encontramos con un problema al crear tu cuenta. Nuestro equipo se pondrá en contacto contigo pronto con toda la información necesaria para tu cuenta.',
		RESTORE_PASSWORD_PAGE_TITLE:
			'Acción requerida: Por favor, restablece tu contraseña',
		RESTORE_PASSWORD_PAGE_INTRO:
			'Para aumentar la seguridad, estamos migrando nuestro sistema de autenticación. Como resultado, será necesario que restablezcas tu contraseña. Este cambio forma parte de nuestros esfuerzos continuos para mejorar la seguridad de tu cuenta y proteger tus datos.',
		RESTORE_PASSWORD_PAGE_SUBTITLE: '¿Qué puedes esperar?',
		RESTORE_PASSWORD_PAGE_DESCRIPTION_1:
			'Transición sin problemas: Estamos trabajando para garantizar que la transición sea lo más fluida posible, con interrupciones mínimas en tu servicio.',
		RESTORE_PASSWORD_PAGE_DESCRIPTION_2:
			'Mayor seguridad: Restablecer tu contraseña ayudará a mantener segura tu cuenta.',
		RESTORE_PASSWORD_PAGE_BUTTON: 'Restablecer contraseña',
		INSURANCE_CERTIFICATE_BUTTON: 'Declaración de Seguros ',
		SHARE_CERTIFY_TITLE: 'Compartir Declaración',
		SHARE_CERTIFY_DESCRIPTION:
			'Latú generará un documento para que lo compartas con tus clientes, proveedores o interesados. Selecciona las pólizas para las cuales deseas crear la declaración.',
		SHARE_CERTIFY_DOWNLOAD: 'Descargar',
		SHARE_CERTIFY_BUTTON: 'Enviar correo',
		INPUT_EMAIL_PLACEHOLDER: 'sucliente@empresa.com',
		INPUT_EMAILS_LIST_PLACEHOLDER:
			'Ingresa una o más direcciones de correo electrónico, separadas por comas.',
		ERROR_LIST_EMAIL_INVALID:
			'El formato de algunos correos electrónicos es incorrecto y no se pudo enviar el correo.',
		CERTIFY_SHARED_SUCCESS: 'Declaración compartido con éxito',
		BILLING_USER_SECTION_TITLE: 'Correo electrónico de facturación',
		BILLING_USER_SECTION_DETAIL:
			'Esta es la dirección de correo electrónico que usaremos para enviar sus facturas e información de pago. Si el correo electrónico no está registrado, solo el titular de la póliza recibirá los correos electrónicos de pago.',
		BILLING_USER_PLACE_HOLDER: 'email@empresa.com',
		BILLING_USER_SECTION_EDIT_CTA: 'Editar email',
		BILLING_USER_SECTION_ADD_CTA: 'Agregar email',
		BILLING_EDIT_TITLE: 'Ingresa tu nuevo email de facturación:',
		BILLING_MODAL_EDIT_CTA: 'Actualizar correo electrónico',
		BILLING_CANCEL_CTA: 'Cancelar',
		BILLING_ADD_EMAIL_SUCCESS: '¡Email de facturación actualizado!',
		BILLING_ADD_EMAIL_SUCCESS_SUBTITLE:
			'A partir de ahora, recibirás todo relacionado con tu factura e información de pago en este nuevo correo electrónico:',
		BILLING_ADD_EMAIL_SUCCESS_CTA: 'Entendido',
		NOT_FOUND_ACCOUNT_TITLE_1: 'Tu correo electrónico',
		NOT_FOUND_ACCOUNT_TITLE_2: 'no está asociado a una cuenta de Latú Seguros.',
		NOT_FOUND_ACCOUNT_INTRO_1:
			'Si tu empresa ya es cliente, solicita a tu administrador que te dé acceso a tu cuenta empresarial.',
		NOT_FOUND_ACCOUNT_INTRO_2:
			'Si aún no eres cliente de Latú Seguros, descubre cómo proteger tu empresa de manera eficaz y confiable. ',
		NOT_FOUND_ACCOUNT_BUTTON: 'Crea tu cuenta',
		INVITE_SUCCESS_RE_SEND_INFO:
			'La invitación ha sido reenviada exitosamente.',
		SEND_PAYMENT_VOUCHER_BUTTON: '¡Envía la factura a tu cliente!',
		INFO_IPAF_QUESTION_PENDING_TO_FILL: 'Aún hay preguntas sin responder.',
		MOBILE_IPAF_INFO_TITLE: '¡Te recomendamos usar la versión web!',
		MOBILE_IPAF_INFO_TEXT:
			'Abre el formulario en nuestra versión web y aprovecha la simplicidad y rapidez al completar la información.',
		MOBILE_IPAF_INFO_BUTTON: 'Ok, entendido.',
		URL_INVALID: 'Url no valida',
		ACCOUNT_PENDING_ACTIVATION_TITLE: 'Aprobación de Cuenta Pendiente',
		ACCOUNT_PENDING_ACTIVATION_INTRO:
			'Gracias por registrarse en nuestro portal de corredores. Actualmente estamos verificando su información para proporcionarle acceso a nuestro sistema de cotización. Este proceso debería completarse en un plazo de 10 días. Si tiene alguna pregunta o si han pasado más de 10 días, por favor contáctenos en contato@latuseguros.com o vía WhatsApp al',
		ACCOUNT_PENDING_ACTIVATION_BTN: 'Explorar Latú Seguros',
		COMPANY_ALREADY_HAS_AN_IPAF_1:
			'La empresa que estás intentando cotizar ya está registrada bajo el corredor de seguros',
		COMPANY_ALREADY_HAS_AN_IPAF_TITLE: '¡La empresa ya está registrada!',
		COMPANY_ALREADY_HAS_AN_IPAF_2:
			'Para obtener una cotización, por favor contáctalos usando el siguiente correo electrónico:',
		COMPANY_ALREADY_HAS_AN_IPAF_3:
			'Si crees que esto es un error y la empresa no debería estar asociada a la compañía corredora, por favor envíanos un correo a',
		DAYS_LEFT: 'días',
		BROKER_MONTH_SLIDER_APPROVED: 'Aprovado',
		BROKER_MONTH_SLIDER_NEED_ACTION: 'Enviar novamente',
		BROKER_MONTH_SLIDER_WAITING_APPROVAL: 'Aguardando Aprovação',
		START_PRE_IPAF: 'Guardar y continuar',
		SUCCESS_SCREEN_1_TITTLE: '¡Cuestionario finalizado con éxito!',
		SUCCESS_SCREEN_1_SUBTITTLE:
			'Su cotización ya está en proceso y se le notificará tan pronto como esté disponible.',
		SUCCESS_SCREEN_1_STEPS_A_TITLE: 'ETAPA 1',
		SUCCESS_SCREEN_1_STEPS_A_SUBTITLE: 'Recolección de datos',
		SUCCESS_SCREEN_1_STEPS_B_TITLE: 'ETAPA ACTUAL',
		SUCCESS_SCREEN_1_STEPS_B_SUBTITLE: 'Análisis de datos',
		SUCCESS_SCREEN_1_STEPS_C_TITLE: 'ETAPA 3',
		SUCCESS_SCREEN_1_STEPS_C_SUBTITLE: 'Presentación de la cotización',
		SUCCESS_SCREEN_1_STEPS_D_TITLE: 'ETAPA 4',
		SUCCESS_SCREEN_1_STEPS_D_SUBTITLE: 'Cobertura activa',
		SUCCESS_SCREEN_1_BUTTON_FROM_LINK: 'Ir a Latú Seguros',
		SUCCESS_SCREEN_1_BUTTON_FROM_USER_APP: 'Cerrar',
		SUCCESS_SCREEN_1_BUTTON_FROM_BROKER_APP: 'Cerrar',
		SUCCESS_SCREEN_1_REMAINING_DAYS_INFO_A: '',
		SUCCESS_SCREEN_1_REMAINING_DAYS_INFO_B:
			'Gracias por la información, empezaremos a trabajar en una cotización ahora mismo.',
		IPAF_LISTENER_TITLE_GUEST:
			'Seu cliente realizou algumas alterações. Gostaria de atualizar o formulário e visualizar todas as modificações?',
		IPAF_LISTENER_TITLE_BROKER:
			'Seu corretor realizou algumas alterações. Gostaria de atualizar o formulário e visualizar todas as modificações?',
		IPAF_LISTENER_SUBTITLE:
			'Ao confirmar a atualização, suas respostas não salvas serão descartadas e o formulário será atualizado para a versão mais atual',
		TITLE_MODAL_FINISH_NOTIFICATION: '¡El cuestionario ha sido finalizado! ',
		TEXT_MODAL_FINISH_NOTIFICATION:
			'Vamos a redirigirle a la siguiente página para que pueda visualizar las próximas etapas de su recorrido.',
		WARNING_INFO_FINISH_NOTIFICATION_1:
			'Para visualizar todas las respuestas de su cuestionario de riesgo, acceda a:',
		WARNING_INFO_FINISH_NOTIFICATION_2:
			' Tablero de tareas > Panel de control.',
		ACTION_FINISH_NOTIFICATION: 'Entendido',
		WARNING_INFO_FINISH_NOTIFICATION_TO_GUEST:
			'Seu broker entrará em contato com você assim que a cotação estiver pronta.',
		INITIAL_QUESTIONS_TITLE: 'Preguntas iniciales',
		INITIAL_QUESTIONS_SUBTITLE:
			'Esta información es importante para generar el cuestionario más preciso para tu negocio.',
		EXIT_IPAF_LINK: 'Salir',
		IPAF_HEADER_TITLE: 'Cuestionario de seguros',
		POLICY_DETAIL_PENDING_SIGNATURE:
			'Seu cliente tem que assinar a proposta de seguro {{insurance_name}}! Enviamos um email diretamente a ele.',
		SIGNATARIO_EDIT_TOAST_SUCCESS:
			'Dados do signatário foram atualizados com sucesso!',
		ADMIN_EDIT_TOAST_SUCCESS:
			'Dados do administrador da conta foram atualizados com sucesso!',
		TITLE_MODAL_REJECT_IPAF:
			'Cotización rechazada por no cumplir con nuestra política de aceptación',
		TEXT_MODAL_REJECT_IPAF:
			'Podrá intentar enviarnos nuevamente esta solicitud en 3 meses.',
		TEXT_MODAL_WARNING_INFO_1:
			'Si tiene dudas o no está de acuerdo con nuestra decisión, contacte al soporte de Latú al correo:',
		REJECT_MODAL_PRIMARY_ACTION: ' Ir a la página principal',
		REJECT_MODAL_SECONDARY_ACTION: 'Registrar otra empresa',
		QUOTE_SUBJECTIVITIES_TITLE: 'Subjetividades',
		EXCLUSIONS_GENERIC_INFO_BROKER:
			'Para una descripción detallada de las coberturas y exclusiones, consulte las condiciones generales del producto.',
		EXCLUSIONS_GENERIC_INFO_USER:
			'Para una descripción detallada de las coberturas y exclusiones, consulte las condiciones generales del producto.',
		MULTI_URL_INVALID: 'Ingresa una URL válida',
		DONT_HAVE_URL: 'No tiene URL',
		CHECK_DONT_HAVE_URL: 'No tengo sitio web',
		ADD_NEW_URL: 'Incluir otra URL',
		LABEL_PRODUCT_CARD_SELECTION_APPROVED: 'Disponível para subscrição',
		LABEL_PRODUCT_CARD_SELECTION_REJECTED: 'Fora da política de risco',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_QUOTING: 'Apólice vigente',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_BEING_QUOTED: 'Cotação em andamento',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_POLICY_ANOTHER_BROKER:
			'Carta de nomeação',
		SUCCESS_MESSAGE: '¡Cuestionario completado con éxito!',
		CHECK_STATUS:
			'Consulta el estado actual de tus solicitudes de cotización a continuación:',
		UNDER_REVIEW:
			'¡En revisión! Tu corredor te notificará en un plazo de hasta 72 horas.',
		EXIT: 'Salir',
		DATA_COLLECTION: 'Recolección de datos',
		RISK_ANALYSIS: 'Análisis de riesgo',
		QUOTE_AVAILABLE: 'Cotización disponible',
		ACTIVE_COVERAGE: 'Cobertura activa',
		UNDER_RISK_ANALYSIS: 'En análisis de riesgo',
		FOR_QUESTIONS: 'Para consultas, contáctanos por',
		TEXT_OR_BY_EMAIL_AT: 'o por correo electrónico a',
		ERROR_SUCCESS_PAGE_TITLE: 'Não podemos apresentar cotação para este risco',
		ERROR_SUCCESS_PAGE_SUB_TITLE:
			'Confira o status atual das suas solicitações de cotação abaixo:',
		EMAIL_REGISTERED_ANOTHER_COMPANY:
			'O e-mail já tem uma conta, por favor tente com outro e-mail.',
		EO_DISCLAIMER_1: 'Seguro por Reclamación',
		EO_DISCLAIMER_2:
			'La Aseguradora pagará al Asegurado las pérdidas que este sufra como consecuencia de Reclamaciones presentadas en su contra por Terceros que busquen atribuirle. ',
		EO_BASIC_COVERAGES_TITLE:
			'Coberturas Básicas',
		EO_ADDITIONAL_COVERAGES_TITLE: 'Coberturas Adicionales',
		EO_EXTENSIONS_COVERAGES_TITLE: 'Extensiones de Cobertura',
		REFRESH_DEPLOY_TITLE: 'Atualizações disponíveis!',
		REFRESH_DEPLOY_INFO:
			'Aplicamos melhorias para uma experiência ainda melhor. Recarregue a página para acessar as novidades.',
		REFRESH_DEPLOY_ACTION: 'Atualizar agora',
	},
};
